import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  color?: string;
}

const Toggle = ({ checked, onChange, color = "#FF1493" }: ToggleProps) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input 
        type="checkbox" 
        className="sr-only peer" 
        checked={checked} 
        onChange={onChange} 
      />
      <div 
        className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer 
                   peer-checked:after:translate-x-full peer-checked:after:border-white 
                   after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
                   after:bg-white after:border-gray-300 after:border after:rounded-full 
                   after:h-5 after:w-5 after:transition-all"
        style={{ backgroundColor: checked ? color : undefined }}
      />
    </label>
  );
};

export default Toggle;